/**
 * Notifies piwik of ajax-loaded page views
 */
define('analytics',['controller'], function(controller) {
	var isFirstView = true;
	controller.on(function() {
		if (isFirstView) {
			isFirstView = false;
			return;
		}
		
		// is piwik enabled?
		if (typeof _paq == 'object') {
			_paq.push(["setCustomUrl", location.href]);
			_paq.push(['trackPageView', document.title]);
		}
	})
});

